import Axios from 'axios'
import base_url from '../config/netconfig';
import { getUserToken } from './localdbhelper';
const API_PRE="/api/v1/"
const http=Axios.create()
export const get=(url,cb)=>{
    return http.get(API_PRE+url).then(res=>{
        let body=res.data
        if(body.code==='SUCCESS'){
            cb(null,body.data);
        }else{
            cb(body.msg,null)
        }
    }).catch(err=>{
        cb('服务器未知错误'+err,null)
    })
}
export const post=(url,param,cb)=>{
    return http({
        url:API_PRE+url,
        method:'POST',
        data:param,
        timeout:6*1000*60,
        headers:{
            'token':getUserToken()
        }
    }).then(res=>{
        let body=res.data
        if(body.code==='SUCCESS'){
            cb(null,body.data);
        }else{
            console.log(body.msg)
            cb(body.msg,null)
        }
    }).catch(err=>{
        console.log(err)
        cb('服务器未知错误'+err,null)
    })
}
export const postFile=(url,param,cb)=>{
    if('api/admin/login'===url){
         http.post(url,param)
    }else{
         http.post(url,param,{
            headers:{
                'Content-Type': 'multipart/form-data',
                'token':getUserToken()
            }
        }).then(res=>{
            let body=res.data
            if(body.code==='SUCCESS'){
                cb(null,body.data);
            }else{
                cb(body.msg,null)
            }
        }).catch(err=>{
            cb('服务器未知错误'+err,null)
        })
    }
}